import api from './index'

// 排行榜数据类型定义
export interface RankingItem {
  rank: number
  callsign: string
  uid: string
  display_name: string
  avatar: string
  total_online_time?: number
  online_hours?: number
  session_count?: number
  activity_count?: number
  participated_count?: number
  completed_count?: number
  score?: number
  total_takeoffs?: number
}

export interface RankingsResponse {
  success: boolean
  data: {
    period: string
    rankings: RankingItem[]
    total: number
    period_info: {
      start_time: number
      end_time: number
      start_date: string
      end_date: string
    }
  }
  message: string
}

// 排行榜API类
class RankingsAPI {
  /**
   * 获取在线时长排行榜
   * @param period 时间周期: weekly/monthly/yearly
   * @param limit 返回数量限制
   */
  async getOnlineDurationRankings(period: string = 'weekly', limit: number = 10): Promise<RankingsResponse> {
    try {
      const response = await api.get(`/rankings/online-duration`, {
        params: { period, limit }
      })
      return response
    } catch (error) {
      console.error('获取在线时长排行榜失败:', error)
      throw error
    }
  }

  /**
   * 获取活动参与排行榜
   * @param period 时间周期: weekly/monthly/yearly
   * @param limit 返回数量限制
   */
  async getActivityParticipationRankings(period: string = 'weekly', limit: number = 10): Promise<RankingsResponse> {
    try {
      const response = await api.get(`/rankings/activity-participation`, {
        params: { period, limit }
      })
      return response
    } catch (error) {
      console.error('获取活动参与排行榜失败:', error)
      throw error
    }
  }

  /**
   * 获取综合排行榜
   * @param period 时间周期: weekly/monthly/yearly
   * @param limit 返回数量限制
   */
  async getComprehensiveRankings(period: string = 'weekly', limit: number = 10): Promise<RankingsResponse> {
    try {
      const response = await api.get(`/rankings/comprehensive`, {
        params: { period, limit }
      })
      return response
    } catch (error) {
      console.error('获取综合排行榜失败:', error)
      throw error
    }
  }
}

export const rankingsAPI = new RankingsAPI()
export default rankingsAPI 